import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  "https://shopin-app-cf-production.up.railway.app";

export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

export const apiGet = async (path) => {
  const res = await api.get(path);
  return res.data;
};

export const apiPost = async (path, data) => {
  const res = await api.post(path, data);
  return res.data;
};

export const apiPatch = async (path, data) => {
  const res = await api.patch(path, data);
  return res.data;
};

export const apiDelete = async (path) => {
  const res = await api.delete(path);
  return res.data;
};